import { Col, Row, Card } from "reactstrap";
import EmptyDataMessage from "../../../sharedComponents/ErrorMessages/EmptyDataMessage";

const ReportListEmptyWidget = () => {
    return (
        <Card>
            <Row style={{ height: 'calc(100vh - 170px)' }}>
                <Col style={{overflowY: 'auto', height: '100%', textAlign: 'center', alignContent: 'center'}}>
                    <EmptyDataMessage />
                </Col>
            </Row>
        </Card>
    )
}

export default ReportListEmptyWidget;